import * as React from 'react';

interface ButtonFilledProps {
  as?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  onClick?: EventListener;
  style?: object;
  to?: string;
  type?: string;
  disabled?: boolean;
  'data-testid'?: string;
}

const ButtonFilled: React.FunctionComponent<ButtonFilledProps> = ({
  as = 'button',
  children,
  className = '',
  ...rest
}) => {
  const Component: any = { tag: as };
  return (
    <Component.tag
      className={`btn--filled f6 br2 ${className}`}
      style={{ padding: '.625rem 1.5rem' }}
      {...rest}
    >
      {children}
    </Component.tag>
  );
};

export default ButtonFilled;
